"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Logo = function Logo(_ref) {
  var type = _ref.type,
      size = _ref.size;

  var getImage = function getImage(type) {
    switch (type) {
      case 'normal':
        return require('./logo-normal.png');

      case 'white':
        return require('./logo-white.png');

      case 'icon':
        return require('./logo-icon.png');

      case 'icon-white':
        return require('./logo-icon-white.png');

      case 'text-white':
        return require('./logo-text-white.png');

      default:
        return require('./logo-normal.png');
    }
  };

  var getSize = function getSize(size) {
    switch (size) {
      case 'icon':
        return {
          width: 24
        };

      case 'small':
        return {
          width: 48
        };

      case 'medium':
        return {
          width: 64
        };

      case 'large':
        return {
          width: 96
        };

      case 'full':
        return {
          width: '100%'
        };

      default:
        return {
          width: '100%'
        };
    }
  };

  return _react["default"].createElement("img", {
    alt: "Kangarootime",
    src: getImage(type),
    style: getSize(size)
  });
};

Logo.propTypes = {
  type: _propTypes["default"].oneOf(['normal', 'white', 'icon', 'icon-white', 'text-white']),
  size: _propTypes["default"].oneOf(['icon', 'small', 'medium', 'large', 'full'])
};
Logo.defaultProps = {
  type: 'normal',
  size: 'full'
};
var _default = Logo;
exports["default"] = _default;